// extracted by mini-css-extract-plugin
export var active = "howto_styles-module--active--2afb6";
export var howToNav = "howto_styles-module--how-to-nav--b937a";
export var sectionTitle = "howto_styles-module--sectionTitle--d6961";